// extracted by mini-css-extract-plugin
export default {"backButtonDiv":"BackToButton_backButtonDiv__EceTg","backButton":"BackToButton_backButton__kAWlL","arrowLeft":"BackToButton_arrowLeft__cnGZ0"};